
    <section class="content-header ">
   
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Warehouse List</h1>
    </div>
    </div>
  
    </section>
<!--------------loader-------------------------->
<div *ngIf=loaderShown class="loader"></div>
<!----------------------------------------------->
    
    <section class="content">
    
    <div class="card" *ngIf=cardShown>
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 60%">
     Warehouse Name
    </th>

    <th style="width: 30%">
   Is Not Shop
    </th>

   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
     {{c?.warehouse_name}} 
    </a>
    </td>
    
    <td>
        <mat-checkbox [checked]="c?.is_not_shop" (change)="onCheckboxChange($event,c.warehouse_id)"></mat-checkbox>
    </td>


    <!-- <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm"  (click)='Details();getValue(c._id)'>  
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left" (click)='EditDetails();getValue(c._id)'>  
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    

    
    </td> -->
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>

<!---------------------paging------------------------------------->
<ul class="pagination" *ngIf=cardShown>
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>
 
